export default "assets/images/languages-b7ce1d78.svg";